import { viewportBreakpoints } from 'utils/viewport'
const deviceSize = {
	names: {
		xsDown: 'xsDown',
		xs: 'xs',
		xsUp: 'xsUp',
		smDown: 'smDown',
		sm: 'sm',
		smUp: 'smUp',
		mdDown: 'mdDown',
		md: 'md',
		mdUp: 'mdUp',
		lgDown: 'lgDown',
		lg: 'lg',
		lgUp: 'lgUp',
	},
	
	sizes: {
		xsDown: [ '<', viewportBreakpoints.sm ],
		xs: [ '><', viewportBreakpoints.sm, viewportBreakpoints.md ],
		xsUp: [ '>', viewportBreakpoints.sm ],
		smDown: [ '<', viewportBreakpoints.md ],
		sm: [ '><', viewportBreakpoints.md, viewportBreakpoints.lg ],
		smUp: [ '>', viewportBreakpoints.md ],
		mdDown: [ '<', viewportBreakpoints.lg ],
		md: [ '><', viewportBreakpoints.lg, viewportBreakpoints.xl ],
		mdUp: [ '>', viewportBreakpoints.lg ],
		lgDown: [ '<', viewportBreakpoints.xl ],
		lg: [ '><', viewportBreakpoints.xl, viewportBreakpoints.xxl ],
		lgUp: [ '>', viewportBreakpoints.xl ],
	},
	
	validate: ( size, width ) => {
		const sizes = deviceSize.sizes[ size ]
		
		const validateMethod = sizes[ 0 ]
		
		switch( validateMethod ) {
			case '<':
				return width < sizes[ 1 ]
			
			case '><':
				return width >= sizes[ 1 ] && width < sizes[ 2 ]
			
			case '>':
				return width >= sizes[ 1 ]
			
			default:
				return false;
		}
	},
	
	get: ( width ) => {
		for( const size in deviceSize.sizes ) {
			if( deviceSize.validate( size, width ) ) {
				return size
			}
		}
		
		return 'xl'
	},
	
	all: ( width ) => {
		let result = {}
		for( const size in deviceSize.sizes ) {
			result[ size ] = deviceSize.validate( size, width )
		}
		
		result.isMobile = result.xsDown || result.xs
		result.isTablet = result.smUp && !result.lgUp
		result.isDesktop = result.lgUp
		
		return result
	}
}

export default deviceSize
